export class FlipGraphScores {
  orderNumber: number
  groupName: string
  totalCount: number
  scoreCount: number
  percentScore: number
  percentScoreRounded: number

  constructor(data?: any) {
    this.orderNumber = data?.orderNumber ?? 0
    this.groupName = data?.groupName ?? ''
    this.totalCount = data?.totalCount ?? 0
    this.scoreCount = data?.scoreCount ?? 0
    this.percentScore = data?.percentScore ?? 0
    this.percentScoreRounded = data?.percentScoreRounded ?? 0
  }
}
